import React from 'react';
import PropTypes from 'prop-types';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import Dialog from 'material-ui/Dialog';
import SovosFlatButton from 's1-ui/sovos-flat-button/SovosFlatButton';
import { gridHeaderColorGray } from 'theme/mainColors';
import ContextualGridMenuOptions from 'shared/contextualGridMenuOptions/ContextualGridMenuOptions';

const headerLabelStyle = {
  color: gridHeaderColorGray,
  fontWeight: 400,
  fontSize: 17,
  paddingBottom: 20
};

class ImportProfileGrid extends React.Component {
  constructor(props) {
    super(props);
    this.profileGridColumns = [
      {
        title: 'Name',
        dataKey: 'name',
        width: 300
      },{
        title: 'Description',
        dataKey: 'description'
      },{
        title: 'Type',
        dataKey: 'fileType',
        width: 80
      },{
        title: '',
        width: 70,
        dataKey: 'moreOptions',
        disabled: !props.showMoreOptions
      }
    ];

    this.state = {
      hoveredRow: -1,
      deleteProfileModalOpen: false,
      profileIdToDelete: -1
    };
  }

  componentWillMount(){
    this.props.profileActions.fetchProfileList();
  }

  handleRowSelection = row => this.props.onProfileSelect(this.props.profilesListGridData[row], row);

  handleRowHover = hoveredRow => this.setState({ hoveredRow });

  handleEditProfile = profileId => this.props.history.push({
    pathname: '/edit-import-profile',
    state: { profileId }
  });

  handleDeleteProfileClick = profileIdToDelete => this.setState({ deleteProfileModalOpen: true, profileIdToDelete });

  handleDeleteProfile = () => {
    this.props.profileActions.deleteProfile(this.state.profileIdToDelete);
    this.handleCloseDeleteProfile();
  };

  handleCloseDeleteProfile = () => this.setState({ deleteProfileModalOpen: false, profileIdToDelete: -1 });

  render() {
    const { profilesListGridData, selectedProfileRow } = this.props;
    return (
      <div>
        { profilesListGridData.length > 0 &&
          <Table fixedHeader={ true } onCellClick={ this.handleRowSelection } onRowHover={ this.handleRowHover } >
            <TableHeader displaySelectAll={ false } adjustForCheckbox={ false } style={ { border: 'none' } }>
              <TableRow style={ { border: 'none' } }>
                { this.profileGridColumns.map(({ dataKey, width, title, disabled }) => (
                  !disabled && <TableHeaderColumn
                    key={ dataKey }
                    style={ {width: width || 'auto', ...headerLabelStyle} }
                  >
                    {title}
                  </TableHeaderColumn>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody showRowHover={ true } displayRowCheckbox={ false }>
              { profilesListGridData.map((profile, index) => (
                <TableRow id={ `import-profile-grid-row-${index}` } key={ index } className="import-profile-grid__row" style={ { height: 40, backgroundColor: selectedProfileRow === index ? '#f7f7f7' : '#fff' } }>
                  { this.profileGridColumns.map(({ dataKey, width, disabled }) => (
                    !disabled && <TableRowColumn key={ dataKey } style={ {width: width || 'auto', textOverflow: `${dataKey !== 'moreOptions' ? 'ellipsis' : 'unset'}`} } >{
                      (dataKey !== 'moreOptions') ?
                        profile[dataKey] :
                        this.state.hoveredRow === index && <ContextualGridMenuOptions elementId={ profile.id } onEdit={ this.handleEditProfile } onDelete={ this.handleDeleteProfileClick } editDisabled={ false } deleteDisabled={ false }  />
                    }</TableRowColumn>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        }
        <Dialog
          actions={ [
            <SovosFlatButton
              key="close-delete"
              color="secondary"
              onClick={ this.handleCloseDeleteProfile }
            >
              No
            </SovosFlatButton>,
            <SovosFlatButton
              key="submit-delete"
              onClick={ this.handleDeleteProfile }
            >
              Yes
            </SovosFlatButton>,
          ] }
          modal={ true }
          open={ this.state.deleteProfileModalOpen }
        >
          Are you sure you want to delete this profile?
        </Dialog>
      </div>
    );
  }
}

ImportProfileGrid.propTypes = {
  profilesListGridData: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    description: PropTypes.string,
    map: PropTypes.shape({
      transformedFileType: PropTypes.string
    })
  })).isRequired,
  onProfileSelect: PropTypes.func,
  showMoreOptions: PropTypes.bool,
  profileActions: PropTypes.shape({
    fetchProfileList: PropTypes.func,
    deleteProfile: PropTypes.func,
    fetchProfileById: PropTypes.func
  }).isRequired,
  selectedProfileRow: PropTypes.number,
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired
};

ImportProfileGrid.defaultProps = {
  onProfileSelect: () => null,
  selectedProfileRow: -1,
  showMoreOptions: false
};

export default ImportProfileGrid;



// WEBPACK FOOTER //
// ./src/components/importData/comp/selectImportProfilePanel/comp/importProfileGrid/ImportProfileGrid.js